import { Params } from '@angular/router';

import { BoardOptionalParams } from 'app/dashboard-shared/enums/board-optional-params.enum';

export const BOARD_ADMIN_ROUTE = {
  BOARD_DASHBOARD: {
    name: 'boarddashboard',
    route(year: string): string[] {
      return [...BOARD_ADMIN_ROUTE.route(), this.name, year];
    }
  },
  BOARD_DASHBOARD_GAPRESULTS: {
    name: 'gapresults/:StatsType/:Year/:Scope/:CourseId/:LogicalErrorId',
    route(statsType: string, year: string, scope: string, courseId: string, logicalErrorId: string): string[] {
      return [...BOARD_ADMIN_ROUTE.route(), 'gapresults', statsType, year, scope, courseId, logicalErrorId];
    }
  },
  BOARD_DASHBOARD_WITH_YEAR: {
    name: 'boarddashboard/:Year',
    queryParams(boardId: string): Params {
      return {
        BoardId: encodeURI(boardId)
      };
    },
    route(year: string): string[] {
      return [...BOARD_ADMIN_ROUTE.route(), 'boarddashboard', year];
    }
  },
  BOARD_HELP_CENTER: {
    name: 'helpcenter',
    route(): string[] {
      return [...BOARD_ADMIN_ROUTE.route(), this.name];
    }

  },
  BOARD_INSIGHTS: {
    name: 'boardinsights/:StatsType',
    route(statsType: string, year: string): string[] {
      return [...BOARD_ADMIN_ROUTE.route(), 'boardinsights', statsType, year];
    }
  },
  BOARD_INSIGHTS_WITH_YEAR: {
    name: 'boardinsights/:StatsType/:Year',
    route(statsType: string, year: string): string[] {
      return [...BOARD_ADMIN_ROUTE.route(), 'boardinsights', statsType, year];
    }
  },
  BOARD_INSIGHTS_WITH_DETAIL: {
    name: 'boardinsights/:StatsType/:Year/detail/:gradeLevel',
    queryParams(boardId: string, schoolId: string, scope: string, strandId = '', term = '', gradeLevel = ''): Params {
      return {
        [BoardOptionalParams.Board]: encodeURI(boardId),
        [BoardOptionalParams.School]: encodeURI(schoolId),
        [BoardOptionalParams.Scope]: encodeURI(scope),
        [BoardOptionalParams.Strand]: encodeURI(strandId),
        [BoardOptionalParams.Term]: encodeURI(term),
        [BoardOptionalParams.GradeLevel]: encodeURI(gradeLevel)
      };
    },
    route(statsType: string, year: string, gradeLevel: number): string[] {
      return [...BOARD_ADMIN_ROUTE.route(), 'boardinsights', statsType, year, 'detail', gradeLevel.toString()];
    }
  },
  BOARD_SCHOOL: {
    name: 'school/:SchoolId/:Year',
    route(schoolId: string, year: string) {
      return [...BOARD_ADMIN_ROUTE.route(), 'school', schoolId, year];
    }
  },
  BOARD_SCHOOL_INSIGHTS: {
    name: 'school/:SchoolId/insights/:StatsType/:Year',
    queryParams(boardId: string): Params {
      return {
        BoardId: encodeURI(boardId)
      };
    },
    route(schoolId: string, statsType: string, year: string): string[] {
      return [...BOARD_ADMIN_ROUTE.route(), 'school', schoolId, 'insights', statsType, year];
    }
  },
  BOARD_SCHOOL_INSIGHTS_WITH_DETAIL: {
    name: 'school/:SchoolId/insights/:StatsType/:Year/detail/:gradeLevel',
    queryParams(boardId: string, schoolId: string, scope: string, gradeLevel = ''): Params {
      return {
        [BoardOptionalParams.Board]: encodeURI(boardId),
        [BoardOptionalParams.School]: encodeURI(schoolId),
        [BoardOptionalParams.Scope]: encodeURI(scope),
        [BoardOptionalParams.GradeLevel]: encodeURI(gradeLevel)
      };
    },
    route(statsType: string, year: string, gradeLevel: number): string[] {
      return [...BOARD_ADMIN_ROUTE.route(), 'school', 'insights', statsType, year, 'detail', gradeLevel.toString()];
    }
  },
  DEFAULT: '',
  name: 'boardadmin',
  route(): string[] {
    return ['/', this.name];
  },
  SETTINGS: {
    name: 'settings',
    route(): string[] {
      return [...BOARD_ADMIN_ROUTE.route(), this.name];
    }
  },
  TRAJECTORY_REPORT: {
    name: 'trajectoryreport',
    path: 'trajectoryreport/:schoolId',
    route(schoolId: string): string[] {
      return [...BOARD_ADMIN_ROUTE.route(), this.name, schoolId];
    }
  }

};
